import type * as React from 'react';
import { get } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import passwordResetFetched, {
	type PasswordResetFetchedAction,
	type PasswordResetPayload,
} from '@Application/Security/PasswordResets/Actions/passwordResetFetched';
import passwordResetFetchFailed, {
	type PasswordResetFetchFailedAction,
} from '@Application/Security/PasswordResets/Actions/passwordResetFetchFailed';
import type FetchPasswordReset from '@Application/Security/PasswordResets/Queries/FetchPasswordReset';
import FALLBACK_MESSAGES from '@Application/Security/TokenJourney/FALLBACK_MESSAGES';
import resolveFailureReason from '@Application/Security/TokenJourney/resolveFailureReason';
import parameters from '../../../parameters';

type Actions = PasswordResetFetchedAction | PasswordResetFetchFailedAction;

export default (query: FetchPasswordReset) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await get<PasswordResetPayload>(
				`${parameters.api.host}/api/password-resets/${query.token}`,
			);

			const action = passwordResetFetched(response);
			dispatch(action);
			return action;
		} catch (error) {
			const extractedMessages = extractMessages(error);
			const reason = resolveFailureReason(error);
			const message = extractedMessages?.message ?? FALLBACK_MESSAGES.passwordResetGone;
			const action = passwordResetFetchFailed(extractedMessages, reason, message);
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
